import type { PresenceContact } from '../../lib/useMessagerie';

export type EtatPresence = 'actif' | 'absent' | 'ne_pas_deranger';

export function etatPresence(presence: PresenceContact): EtatPresence {
  if (!presence.enLigne) return 'absent';
  return presence.statut === 'ne_pas_deranger' ? 'ne_pas_deranger' : 'actif';
}

export const LIBELLE_PRESENCE: Record<EtatPresence, string> = {
  actif: 'En ligne',
  absent: 'Absent',
  ne_pas_deranger: 'Ne pas déranger',
};
